<template>
    <hts-drawer
        v-model="visible"
        color="main"
        size="large"
        :title="$t('labels.detailTrip')"
        @close="close">
        <hts-select-order
            v-model="dataEdit.order"
            v-model:text="dataEdit.orderCode"
            disabled />
    </hts-drawer>
</template>

<script setup lang="ts">
import { $api, $urlClient } from '#imports'
const emits = defineEmits(['refreshTables'])

const visible = ref(false)

const dataEdit = ref({
  order: '',
  orderCode: ''
})

const idTrip = ref('')

const open = async (id: string) => {
  idTrip.value = id
  await getData()
  visible.value = true
}

const getData = async () => {
  const api = $urlClient.trip.trip.detail
  const data: any = await $api(api, { uriParams: { ID: idTrip.value } })
  const resData: any = data.data.value

  if (resData?.success) {
    dataEdit.value.order = resData.data.order
    dataEdit.value.orderCode = resData.data.orderCode
  }
}

const close = () => {
  visible.value = false
}

const resetFields = () => {
  dataEdit.value = {
    order: '',
    orderCode: ''
  }
}

defineExpose({ open })
</script>
